var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"outer"}}),(_vm.$route.name !== 'login')?_c('el-container',[_c('el-header',[_c('router-view',{attrs:{"name":"header"}})],1),_c('el-main',[_c('router-view')],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }